import TemplateCreateDocumentW2 from './TemplateCreateDocumentW2'

export default TemplateCreateDocumentW2
